import React from 'react';
import { graphql } from 'react-apollo';
import { QRCodeSVG } from "qrcode.react"
import { renderToStaticMarkup } from 'react-dom/server';

import getModeloNota from '../../graphql/querys/editor/getModeloNota';
import moment from 'moment';

import _ from 'lodash';
import Loading from '../common/LoadingGrommet';

// eslint-disable-next-line no-useless-escape
const HASHTAG_REGEX = /(\#[a-zA-Z0-9_.-]+\#)/gm;
const PESOS_REGEX = /(\$[a-zA-Z0-9_.-]+\$)/gm;

moment.updateLocale('es', {
  months: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
});
moment.locale('es');

class Generador extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      notaGenerada: false,
    };

    this.ejecutarParser = this.ejecutarParser.bind(this);
    this.buscarColecciones = this.buscarColecciones.bind(this);
  }

  componentDidMount() {
    if (this.state.notaGenerada) {
      this.setState({
        notaGenerada: false,
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log('ENTRE AL GENERADORRRRRR: ');
    // console.log(this.props);
    // console.log(nextProps);
    // if (!this.props.data.getModeloNota && nextProps.data.getModeloNota) {
    if (!this.state.notaGenerada && nextProps.data.getModeloNota) {
      // console.log("Se cargo la nota!");
      // console.log(nextProps.data.getModeloNota);

      this.setState(
        {
          notaGenerada: true,
        },
        function() {
          this.ejecutarParser(nextProps.data.getModeloNota.htmlModelo);
        }
      );
    }
  }

  buscarColecciones(htmlModelo) {
    // console.log("Entre al buscar colecciones");

    // eslint-disable-next-line no-unused-vars
    let matchArr, start;
    let nuevoHtml = htmlModelo;

    let regex = PESOS_REGEX;
    let atr = '';
    let count = 0;

    while ((matchArr = regex.exec(htmlModelo)) !== null && count < 200) {
      count++;
      // This is necessary to avoid infinite loops with zero-width matches
      if (matchArr.index === regex.lastIndex) {
        regex.lastIndex++;
      }
      // console.log("Match COLECCIONESs");
      // console.log(matchArr);
      // The result can be accessed through the `m`-variable.
      // eslint-disable-next-line no-unused-vars
      matchArr.forEach((match, groupIndex) => {
        // console.log(`Encontrado! tenemos.. ${groupIndex}: ${match}`);
        atr = match.slice(1, -1);

        if (this.props.datos[atr] && this.props.datos[atr].length > 0) {
          let textoColeccion = '';

          if (atr == 'articulos' || atr == 'expediente_articulos') {
            _.forEach(this.props.datos[atr], elem => {
              textoColeccion = textoColeccion + ' ' + elem.nombre + ' ';
            });
          } else {
            if (atr == 'autorizantes_firmas') {
              let numdoc,
                nacionalidad,
                tipodoc,
                apellidoElem,
                nombreElem = '';
              _.forEach(this.props.datos[atr], elem => {
                // console.log("el elemento es.... ", elem);
                if (elem.tipo_doc) {
                  tipodoc = elem.tipo_doc;
                }
                if (elem.num_doc) {
                  numdoc = ': ' + elem.num_doc;
                }
                if (elem.apellido) {
                  apellidoElem = elem.apellido;
                }
                if (elem.nombre) {
                  nombreElem = elem.nombre;
                }
                textoColeccion =
                  textoColeccion +
                  '<p> </p> <p> </p> <p> </p> <p>' +
                  apellidoElem +
                  ' ' +
                  nombreElem +
                  '\n ' +
                  tipodoc +
                  ' N° ' +
                  numdoc +
                  '</p>';
                numdoc, tipodoc, apellidoElem, (nombreElem = '');
              });
            } else {
              if (
                atr == 'autorizantes_sin_domicilio' ||
                atr == 'responsables_sin_domicilio'
              ) {
                let numdoc, tipodoc, apellidoElem, nombreElem;
                _.forEach(this.props.datos[atr], elem => {
                  // console.log("el elemento es.... ", elem, "  y entre por.... ", atr);
                  if (elem.tipo_doc) {
                    tipodoc = elem.tipo_doc;
                  }
                  if (elem.num_doc) {
                    numdoc = ': ' + elem.num_doc;
                  }
                  if (elem.apellido) {
                    apellidoElem = elem.apellido;
                  }
                  if (elem.nombre) {
                    nombreElem = elem.nombre;
                  }
                  textoColeccion =
                    textoColeccion +
                    apellidoElem +
                    ' ' +
                    nombreElem +
                    ' ' +
                    tipodoc +
                    numdoc +
                    ', ';
                  numdoc, tipodoc, apellidoElem, (nombreElem = '');
                });
              } else {
                if (
                atr == 'autorizantes_con_domicilio' ||
                atr == 'responsables_con_domicilio'
              ) {
                let numdoc,
                  nacionalidad,
                  fechaNacimiento,
                  tipodoc,
                  apellidoElem,
                  domicilioElem,
                  nombreElem = '';
                _.forEach(this.props.datos[atr], elem => {
                  // console.log("el elemento es.... ", elem, "  y entre por.... ", atr);
                  if (elem.tipo_doc) {
                    tipodoc = elem.tipo_doc;
                  }
                  if (elem.num_doc) {
                    numdoc = ': ' + elem.num_doc;
                  }
                  if (elem.apellido) {
                    apellidoElem = elem.apellido;
                  }
                  if (elem.nombre) {
                    nombreElem = elem.nombre;
                  }
                  if(elem.nacionalidad){
                    nacionalidad = " de nacionalidad " + elem.nacionalidad;
                  } else {
                    nacionalidad = '';
                  }

                  if(elem.fecha_nacimiento){
                    fechaNacimiento = " con fecha de nacimiento el " + moment(elem.fecha_nacimiento).format('DD/MM/YYYY');
                  }else{
                    fechaNacimiento = " con fecha de nacimiento el DD/MM/YYYY" 
                  }
                  if (elem.direccion_calle) {
                    domicilioElem =
                      ' con domicilio en ' + elem.direccion_calle;

                    if (elem.direccion_numero) {
                      domicilioElem =
                        domicilioElem + ' ' + elem.direccion_numero;
                    }
                  } else {
                    domicilioElem = '';
                  }
                  textoColeccion =
                    textoColeccion +
                    apellidoElem +
                    ' ' +
                    nombreElem +
                    nacionalidad +
                    ' ' +
                    tipodoc +
                    numdoc +
                    " " +
                    fechaNacimiento +
                    domicilioElem +
                    ', ';
                  numdoc, tipodoc, apellidoElem, nombreElem, nacionalidad, domicilioElem = '';
                });
                
                console.log("Antes del if que me importa, " + atr)
              }else{
                if (
                atr == 'autorizantes_con_formatoHtml'
              ) {
                let numdoc,
                  nacionalidad,
                  fechaNacimiento,
                  tipodoc,
                  apellidoElem,
                  domicilioElem,
                  vinculo,
                  nombreElem = '';
                  _.forEach(this.props.datos[atr], elem => {
                    // console.log("el elemento es.... ", elem, "  y entre por.... ", atr);
                    if (elem.tipo_doc) {
                      tipodoc = elem.tipo_doc;
                    }
                    if (elem.num_doc) {
                      numdoc = elem.num_doc;
                    }
                    if (elem.apellido) {
                      apellidoElem = elem.apellido;
                    }
                    if (elem.nombre) {
                      nombreElem = elem.nombre;
                    }
                    if(elem.nacionalidad){
                      nacionalidad = elem.nacionalidad;
                    } else {
                      nacionalidad = '';
                    }
                    if(elem.vinculo){
                      vinculo = elem.vinculo
                    }

                    if(elem.fecha_nacimiento){
                      fechaNacimiento = "" + moment(elem.fecha_nacimiento).format('DD/MM/YYYY');
                    }else{
                      fechaNacimiento = "DD/MM/YYYY" 
                    }
                    if (elem.direccion_calle) {
                      domicilioElem =
                        elem.direccion_calle;

                      if (elem.direccion_numero) {
                        domicilioElem =
                          domicilioElem + ' ' + elem.direccion_numero;
                      }

                      if (elem.localidad && elem.localidad.nombre) {
                        domicilioElem =
                          domicilioElem + ', ' + elem.localidad.nombre;
                      }
                    } else {
                      domicilioElem = '';
                    }

                      textoColeccion =
                          textoColeccion +
                          "Autorizante: " +nombreElem + " " + apellidoElem + "</br>" +
                          "Vinculo: " + vinculo + "</br>" +
                          "Nacionalidad: " + nacionalidad + "</br>" + 
                          "Tipo Doc.: " + tipodoc + "</br>" +
                          "Num. Doc.: " + numdoc +"</br>" +
                          "Domicilio: "+ domicilioElem + "</br>" +
                          "Fecha Nacimiento: " + fechaNacimiento + "</br>"  + 
                          "</br>"

                    numdoc, tipodoc, apellidoElem, nombreElem, nacionalidad, domicilioElem = '';
                });
              }else{
                if(
                  atr == 'autorizantes_trabajo_menor'
                ){
                  let numdoc,
                  nacionalidad,
                  fechaNacimiento,
                  tipodoc,
                  apellidoElem,
                  domicilioElem,
                  vinculo,
                  nombreElem = '';
                  _.forEach(this.props.datos[atr], elem => {
                    // console.log("el elemento es.... ", elem, "  y entre por.... ", atr);
                    if (elem.tipo_doc) {
                      tipodoc = elem.tipo_doc;
                    }
                    if (elem.num_doc) {
                      numdoc = elem.num_doc;
                    }
                    if (elem.apellido) {
                      apellidoElem = elem.apellido;
                    }
                    if (elem.nombre) {
                      nombreElem = elem.nombre;
                    }
                    if(elem.nacionalidad){
                      nacionalidad = elem.nacionalidad;
                    } else {
                      nacionalidad = '';
                    }
                    if(elem.vinculo){
                      vinculo = elem.vinculo
                    }

                    if(elem.fecha_nacimiento){
                      fechaNacimiento = "" + moment(elem.fecha_nacimiento).format('DD/MM/YYYY');
                    }else{
                      fechaNacimiento = "DD/MM/YYYY" 
                    }
                    if (elem.direccion_calle) {
                      domicilioElem =
                        elem.direccion_calle;

                      if (elem.direccion_numero) {
                        domicilioElem =
                          domicilioElem + ' ' + elem.direccion_numero;
                      }

                      if (elem.localidad && elem.localidad.nombre) {
                        domicilioElem =
                          domicilioElem + ', ' + elem.localidad.nombre;
                      }
                    } else {
                      domicilioElem = '';
                    }

                      textoColeccion =
                          textoColeccion +
                          "Autorizante: " +nombreElem + " " + apellidoElem + "</br>" +
                          "Vinculo: " + vinculo + "</br>" +
                          "Nacionalidad: " + nacionalidad + "</br>" + 
                          "Tipo Doc.: " + tipodoc + "</br>" +
                          "Num. Doc.: " + numdoc +"</br>" +
                          "Domicilio: "+ domicilioElem + "</br>" +
                          "Fecha Nacimiento: " + fechaNacimiento + "</br>"  + 
                          "</br>" +
                          "Cuyo vínculo de parentesco acredita con Acta de Nacimiento N° "+ this.props.datos.numero_acta_nacimiento + 
                          " del Registro Civil y Capacidad de las Personas de " + vinculo + " Representacion legal que acredito con " + 
                          "(Poder inscripto, Sentencia Judicial)" +
                          "</br>"

                    numdoc, tipodoc, apellidoElem, nombreElem, nacionalidad, domicilioElem = '';
                });
                }else{
                  if(atr == "certifica_trabajo_menor"){
                    textoColeccion = "<strong>CERTIFICO:</strong> Que las firmas que anteceden son auténticas y pertenecen "
                      let numdoc,
                      nacionalidad,
                      fechaNacimiento,
                      tipodoc,
                      apellidoElem,
                      domicilioElem,
                      vinculo,
                      nombreElem = '';
                      _.forEach(this.props.datos[atr], elem => {
                        // console.log("el elemento es.... ", elem, "  y entre por.... ", atr);
                        if (elem.num_doc) {
                          numdoc = elem.num_doc;
                        }
                        if (elem.apellido) {
                          apellidoElem = elem.apellido;
                        }
                        if (elem.nombre) {
                          nombreElem = elem.nombre;
                        }
                        if(elem.vinculo){
                          vinculo = elem.vinculo
                        }

                        if (elem.direccion_calle) {
                          domicilioElem =
                            elem.direccion_calle;

                          if (elem.direccion_numero) {
                            domicilioElem =
                              domicilioElem + ' ' + elem.direccion_numero;
                          }

                          if (elem.localidad && elem.localidad.nombre) {
                            domicilioElem =
                              domicilioElem + ', ' + elem.localidad.nombre;
                          }
                        } else {
                          domicilioElem = '';
                        }

                          textoColeccion =
                              textoColeccion +
                                "al/a la Sr./Sra. "+nombreElem +" " + apellidoElem+ " DNI Nº" + numdoc, 
                              
                        numdoc, tipodoc, apellidoElem, nombreElem, nacionalidad, domicilioElem = '';
                    });
                  textoColeccion = textoColeccion + " y al/la trabajador/a adolescente " + this.props.datos.autorizado.nombre + " " + this.props.datos.autorizado.apellido + " DNI Nº" + this.props.datos.autorizado.num_doc 
                  } else {
                if (atr == 'responsables') {
                  let numdoc,
                    tipodoc,
                    apellidoElem,
                    nombreElem,
                    nacionalidad,
                    domicilioElem = '';

                  for (let i = 0; i < this.props.datos[atr].length; i++) {
                    const elem = this.props.datos[atr][i];
                    // console.log("el elemento es.... ", elem, "  y entre por.... ", atr);
                    if (elem.tipo_doc) {
                      tipodoc = elem.tipo_doc;
                    }
                    if (elem.num_doc) {
                      numdoc = ': ' + elem.num_doc;
                    }
                    if(elem.nacionalidad){
                      nacionalidad=" nacionalidad: " + elem.nacionalidad;
                    }
                    if (elem.apellido) {
                      apellidoElem = elem.apellido;
                    }
                    if (elem.nombre) {
                      nombreElem = elem.nombre;
                    }
                    if (elem.direccion_calle) {
                      domicilioElem =
                        'con domicilio en ' + elem.direccion_calle;

                      if (elem.direccion_numero) {
                        domicilioElem =
                          domicilioElem + ' ' + elem.direccion_numero;
                      }
                    }

                    if (i < this.props.datos[atr].length - 1) {
                      textoColeccion =
                        textoColeccion +
                        apellidoElem +
                        ' ' +
                        nombreElem +
                        ' ' +
                        tipodoc +
                        numdoc +
                        ' ' +
                        domicilioElem +
                        '; y/o ';
                    } else {
                      textoColeccion =
                        textoColeccion +
                        apellidoElem +
                        ' ' +
                        nombreElem +
                        ' ' +
                        tipodoc +
                        numdoc +
                        ' ' +
                        domicilioElem;
                    }
                    numdoc, tipodoc, apellidoElem, (nombreElem = '');
                  }
                } else {
                  if (atr == 'responsables_simple') {
                  let numdoc,
                    tipodoc,
                    apellidoElem,
                    nombreElem,
                    nacionalidad,
                    domicilioElem = '';
                    

                  for (let i = 0; i < this.props.datos[atr].length; i++) {
                    const elem = this.props.datos[atr][i];
                    // console.log("el elemento es.... ", elem, "  y entre por.... ", atr);
                    if (elem.tipo_doc) {
                      tipodoc = elem.tipo_doc;
                    }
                    if (elem.num_doc) {
                      numdoc = ': ' + elem.num_doc;
                    }
                    if(elem.nacionalidad){
                      nacionalidad=" nacionalidad: " + elem.nacionalidad;
                    }
                    if (elem.apellido) {
                      apellidoElem = elem.apellido;
                    }
                    if (elem.nombre) {
                      nombreElem = elem.nombre;
                    }
                    if (elem.direccion_calle) {
                      domicilioElem =
                        'con domicilio en ' + elem.direccion_calle;

                      if (elem.direccion_numero) {
                        domicilioElem =
                          domicilioElem + ' ' + elem.direccion_numero;
                      }
                    }

                    if (i < this.props.datos[atr].length - 1) {
                      textoColeccion =
                        textoColeccion +
                        apellidoElem +
                        ' ' +
                        nombreElem +
                        " (padre/ madre/ tercero) " +
                        tipodoc +
                        numdoc +
                        '; y/o ';
                    } else {
                      textoColeccion =
                        textoColeccion +
                        apellidoElem +
                        ' ' +
                        nombreElem +
                        ' ' +
                        " (padre/ madre/ tercero) " +
                        tipodoc +
                        numdoc 
                    }
                }
                if(textoColeccion == ""){
                  textoColeccion = "___________________"
                }
               } else {
                  let numdoc,
                    tipodoc,
                    apellidoElem,
                    nombreElem,
                    domicilioElem = '';
                  _.forEach(this.props.datos[atr], elem => {
                    // console.log("el elemento es.... ", elem);
                    if (elem.tipo_doc) {
                      tipodoc = elem.tipo_doc;
                    }
                    if (elem.num_doc) {
                      numdoc = ': ' + elem.num_doc;
                    }
                    if (elem.apellido) {
                      apellidoElem = elem.apellido;
                    }
                    if (elem.nombre) {
                      nombreElem = elem.nombre;
                    }
                    if (elem.direccion_calle && elem.direccion_numero) {
                      domicilioElem =
                        'con domicilio en ' +
                        elem.direccion_calle +
                        ' ' +
                        elem.direccion_numero;
                    }
                    textoColeccion =
                      textoColeccion +
                      apellidoElem +
                      ' ' +
                      nombreElem +
                      ' ' +
                      tipodoc +
                      numdoc +
                      ' ' +
                      domicilioElem +
                      ', ';
                    numdoc,
                      tipodoc,
                      apellidoElem,
                      nombreElem,
                      (domicilioElem = '');
                  });
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
          nuevoHtml = nuevoHtml.replace(match, textoColeccion);
        }
        //Texto default para alguns campos. Para que no queden con el nombre de la variable

        if (atr == 'responsables_simple') {
          nuevoHtml = nuevoHtml.replace(match, "________________________ (padre/ madre/ tercero) DNI:___________");

        }
      });
      start = matchArr.index;
    }

    // console.log("El string final es...");
    // console.log(nuevoHtml);

    return nuevoHtml;
  }

  ejecutarParser(htmlModelo) {
    // console.log("Entre al parser");

    // eslint-disable-next-line no-unused-vars
    let matchArr, start;
    let nuevoHtml = htmlModelo;

    let regex = HASHTAG_REGEX;
    let atr = '';
    let count = 0;

    let fecha =
      this.props.datos && this.props.datos.fecha_creacion
        ? moment(this.props.datos.fecha_creacion)
        : moment();

    let nuevos_datos = {
      ...this.props.datos,
      localidad: this.props.datos.localidad
        ? this.props.datos.localidad.nombre
        : undefined,
      dias: fecha.format('D'),
      mes: fecha.format('MMMM'),
      anio: fecha.format('YYYY'),
    };
    // console.log('LOS NUEVOS DATOS SON...');
    // console.log(nuevos_datos);
    this.props.datos.dia = fecha.format('D');
    this.props.datos.mes = fecha.format('MMMM');
    this.props.datos.anio = fecha.format('YYYY');

    while ((matchArr = regex.exec(htmlModelo)) !== null && count < 200) {
      count++;
      // This is necessary to avoid infinite loops with zero-width matches
      if (matchArr.index === regex.lastIndex) {
        regex.lastIndex++;
      }
      // console.log("Match");
      // console.log(matchArr);
      // The result can be accessed through the `m`-variable.
      // eslint-disable-next-line no-unused-vars
      matchArr.forEach((match, groupIndex) => {
        // console.log(`Encontrado! tenemos.. ${groupIndex}: ${match}`);
        atr = match.slice(1, -1);

        //Aca hacer logica para si atr es añidado
        var particiones = atr.split('.');

        //Si detectamos que es añidado la variable, entonces debemos recorrer el objeto.
        //Por ejemplo, para #autorizado.nombre# debemos ir a nuevos_datos.autorizado.nombre
        //Sino, simplemente remplazamos (caso #tipo_autorizacion# por nuevos_datos.tipo_autorizacion)
        if (particiones.length > 1) {
          if (
            particiones.length == 2 &&
            nuevos_datos[particiones[0]] &&
            nuevos_datos[particiones[0]][particiones[1]]
          ) {
            let value = nuevos_datos[particiones[0]][particiones[1]];
            
            // Format fecha_nacimiento if it's a date field
            if (particiones[1] === 'fecha_nacimiento' && value) {
              value = moment(value).format('DD/MM/YYYY');
            }
            
            nuevoHtml = nuevoHtml.replace(match, value);
          } else {
            if (
              particiones.length == 3 &&
              nuevos_datos[particiones[0]] &&
              nuevos_datos[particiones[0]][particiones[1]] &&
              nuevos_datos[particiones[0]][particiones[1]][particiones[2]]
            ) {
              let value = nuevos_datos[particiones[0]][particiones[1]][particiones[2]];
              
              // Format fecha_nacimiento if it's a date field
              if (particiones[2] === 'fecha_nacimiento' && value) {
                value = moment(value).format('DD/MM/YYYY');
              }
              
              nuevoHtml = nuevoHtml.replace(match, value);
            }else{
               if(particiones.length == 2 &&
            nuevos_datos[particiones[0]]){
              let value = "---"
              if(particiones.includes("domicilio")){
                let domicilioElem = "";
                  if (nuevos_datos[particiones[0]].direccion_calle) {
                    domicilioElem =
                      nuevos_datos[particiones[0]].direccion_calle;

                    if (nuevos_datos[particiones[0]].direccion_numero) {
                      domicilioElem =
                        domicilioElem + ' ' + nuevos_datos[particiones[0]].direccion_numero;
                    }

                    if (nuevos_datos[particiones[0]].localidad && nuevos_datos[particiones[0]].localidad.nombre){
                      domicilioElem = domicilioElem + ', ' +nuevos_datos[particiones[0]].localidad.nombre;
                    }
                  }
                  value = domicilioElem
              }
              nuevoHtml = nuevoHtml.replace(match, value);
            }
            }
          }
        } else {

          // Support for codigoUnicoVerificacion with custom path like codigoUnicoVerificacion-trabajoMenor
          if (atr.startsWith('codigoUnicoVerificacion-') && nuevos_datos['codigoUnicoVerificacion']) {
            const urlPath = atr.split('-')[1]; // Extract the path after the dash
            // Generate SVG string for the QR code
            const qrSvg = getQrSvgString("https://sijup.jusneuquen.gov.ar/" + urlPath + "/" + nuevos_datos['codigoUnicoVerificacion'] , {size:100});
            nuevoHtml = nuevoHtml.replace(
              match,
              qrSvg + `<div style="word-break:break-all;font-size:10px;color:#888;">${nuevos_datos['codigoUnicoVerificacion']}</div>`
            );
          } else if (atr === 'codigoUnicoVerificacion' && nuevos_datos[atr]) {
            console.log("ingrese con codigoUNico")
            // Default to viajeMenor if no tipo is specified
            const urlPath = "viajeMenor";
            // Generate SVG string for the QR code
            const qrSvg = getQrSvgString("https://sijup.jusneuquen.gov.ar/" + urlPath + "/" + nuevos_datos[atr] , {size:100});
            console.log("🚀 ~ matchArr.forEach ~ qrSvg:", qrSvg)
            nuevoHtml = nuevoHtml.replace(
              match,
              qrSvg + `<div style="word-break:break-all;font-size:10px;color:#888;">${nuevos_datos[atr]}</div>`
            );
          } else if (nuevos_datos[atr]) {
            nuevoHtml = nuevoHtml.replace(match, nuevos_datos[atr]);
          }
        }

        // console.log(nuevos_datos[atr]);
      });
      start = matchArr.index;
      //   callback(start, start + matchArr[0].length);
    }
    nuevoHtml = this.buscarColecciones(nuevoHtml);
    this.props.mostrarEditor(nuevoHtml);
  }

  render() {
    let loading = this.props.data && this.props.data.loading;

    return (
      <Loading isLoading={loading}>
        <h1> Generando HTML...... </h1>
      </Loading>
    );
  }
}

function getQrSvgString(value, options = {}) {
  //Genera el SVG para el QR que va en el html/pdf
  return renderToStaticMarkup(
    <QRCodeSVG
      value={value}
      size={options.size || 120}
      includeMargin={true}
      level0={'H'}
    />
  );
}

export default graphql(getModeloNota, {
  options: props => {
    return { variables: { id: props.id }, fetchPolicy: 'network-only' };
  },
})(Generador);
